













import Vue, { PropType } from 'vue';
import { MenuItem } from './types';

export default Vue.extend({
    name: 'LeftMenuItem',

    props: {
        item: Object as PropType<MenuItem>,
    },

    // костыль для circular dependencies
    beforeCreate() {
        (this as any).$options.components.LeftMenu = require('./LeftMenu.vue').default;
    },
});
